export default "__VITE_ASSET__ByONSPI$__"